import { locationsReducer } from './locations.reducer'
export * from './locations.thunks'
export * from './locations.actions'

export default locationsReducer
